import React, {useEffect} from 'react';
import {Routes, Route, useNavigate, useLocation} from 'react-router-dom'
import GroupList from '../group/group-list';
import GroupDetails from '../group/group-details';
import Register from '../user/register';
import Account from '../user/account';
import Event from '../events/event';
import EventForm from '../events/event-form';
import Login from "../user/login";
import {useAuth} from "../../hooks/useAuth";


function Main() {
    const { authData } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(()=> {
        if (!authData){
            if(location.pathname !== "/account" && location.pathname !== "/login" && location.pathname !== "/register"){
                navigate('/login');
            }
        }
    },[authData, navigate, location])

  return (
      <div className={"w-full p-2"}>
          <Routes>
              <Route exact path="/" element={<GroupList/>} />
              <Route path="/details/:id" element={<GroupDetails/>} />
              <Route path="/event/:id" element={<Event/>} />
              <Route path="/event-form" element={<EventForm/>} />

              <Route path="/account" element={<Account/>} />
              <Route path="/login" element={<Login/>} />
              <Route path="/register" element={<Register/>} />
        </Routes>
      </div>
  );
}

export default Main;